
import {
    GESTION_OPERATIVA_ADD_USADO_A_ENTREGAR,
  } from '../constants'


  export function addUsadoAEntregar(car, status = false){
    return (dispatch) => {
        dispatch({
            type: GESTION_OPERATIVA_ADD_USADO_A_ENTREGAR,
            data:  {car, status} 
        })
    }
}